

export class OutsourcingTypeResponseModel {
    count:number
    next:string
    previous:string
    results: OutsourcingTypeModel[]
}

export class OutsourcingTypeModel {
  id: number;
  name: string;
  description: string;
  image: string;
  created_at: Date;
  created_by: number;
  updated_at: Date;
  updated_by: number;
}

export class OutsourcingRequestResponseModel {
    count:number
    next:string
    previous:string
    results: OutsourcingRequestModel[]
}

export class OutsourcingRequestModel {
  status: string
  created_by: number
  modified_by: number
  event: number
  outsourcing_type: number
  id:number
  category:number
  event_details:string 
  outsourcing_type_details:any 
  status_name :string
  quotation_count:number 
  is_shortlisted:boolean 
  is_finalized :boolean
  payment_status :string
  outsourcing_form:string
  outsourcing_form_name:string
}


export class OutsourcingForm {
  id :number
  created_by_name	:string 
  modified_by_name :string
  category_details :string
  created_at :string
  modified_at :string
  name:string	 
  description	: string 
  status:string	 
  created_by:number 
  modified_by	:number 
  category:number
  
}

export class OutsourcingFormResponseModel {
  count:number
  next:string
  previous:string
  results: OutsourcingForm[]
}